import creationToolContainerSelector from './desmos_creation_tool_container_selector'
import desmosCategorySelector from './desmos_category_selector'
import saveSelector from './desmos_save_selector'
import desmosValidationSelector from './desmos_validation_selector'

export default {
	creationToolContainerSelector,
	desmosCategorySelector,
	saveSelector,
	desmosValidationSelector,
}
